import { Component, Input } from '@angular/core';

@Component({
  selector: 're-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrl: './login-footer.component.css',
})
export class LoginFooterComponent {
  @Input() version!: string;
  @Input() buildDate!: string;
  @Input() baseUrl!: string;
  @Input() message!: string;
  @Input() qaBuild = false;
}
